<script lang="ts">
  import AzimuthLiveHero from '$lib/components/sections/AzimuthLiveHero.svelte';
  import BenchmarkResults from '$lib/components/sections/BenchmarkResults.svelte';
  import EvmbenchResults from '$lib/components/sections/EvmbenchResults.svelte';
  import SocialProof from '$lib/components/sections/SocialProof.svelte';
  import BackedBy from '$lib/components/sections/BackedBy.svelte';
  import Contact from '$lib/components/sections/Contact.svelte';
</script>

<svelte:head>
  <title>TestMachine — Security Infrastructure for Web3</title>
  <meta name="description" content="AI-powered Web3 security. Continuous penetration testing, vulnerability detection, and automated fixes for smart contracts and blockchain protocols." />
  
  <!-- Open Graph meta tags -->
  <meta property="og:title" content="TestMachine — Web3 Security That Actually Works" />
  <meta property="og:description" content="AI-powered Web3 security. Continuous penetration testing, vulnerability detection, and automated fixes for smart contracts and blockchain protocols." />
  <meta property="og:image" content="https://testmachine.ai/testmachine-og-logo.png" />
  <meta property="og:url" content="https://testmachine.ai" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="TestMachine" />
  
  <!-- Twitter Card meta tags -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="TestMachine — Web3 Security That Actually Works" />
  <meta name="twitter:description" content="AI-powered Web3 security. Continuous penetration testing, vulnerability detection, and automated fixes for smart contracts and blockchain protocols." />
  <meta name="twitter:image" content="https://testmachine.ai/testmachine-og-logo.png" />
</svelte:head>

<!-- Live Azimuth protocol-scan dashboard — the first thing visitors see
     (ported from azimuth-live; data via /api/public/azimuthLive/*). -->
<AzimuthLiveHero />

<!-- Benchmark chart + testimonials: headline spans both; side by side on
     desktop, stacked on mobile -->
<div class="proof-row">
  <h2 class="proof-title">
    We build security infrastructure for the agentic age<span class="dim">…</span>
    <span class="accent">and it works</span>
  </h2>
  <EvmbenchResults />
  <BenchmarkResults />
  <SocialProof />
</div>

<!-- Backed By -->
<BackedBy />

<!-- Contact Form -->
<Contact />

<style>
  /* Headline above the stacked chart + testimonials. */
  .proof-title {
    font-family: var(--font-display);
    font-size: clamp(1.875rem, 4vw, 3rem);
    font-weight: 700;
    line-height: 1.12;
    letter-spacing: -0.025em;
    text-align: center;
    max-width: 22ch;
    margin: 0 auto 40px;
  }
  .proof-title .accent {
    color: var(--accent);
  }
  .proof-title .dim {
    color: var(--fg-dim);
  }

  /* Uniform section gap: each boundary (viz→chart→testimonials→investors→
     get-in-touch) is exactly one var(--section-py). Each section owns only its
     top gap; the section above contributes none. This is the viz→chart gap. */
  .proof-row {
    padding-top: var(--section-py);
  }
</style>
